import axios from 'axios';
import { API_URL } from '../config';

export default class {

    static get = async () => {
        let result = {
            data: null,
            error: null
        };

        await axios.get(`${API_URL}/settings/`)
            .then(resp => {
                if (resp.status === 200) {
                    result.data = resp.data;
                }
            })
            .catch(err => {
                result.error = err.response ? err.response.data : (err.message || "Server Error");
            });

        return result;
    }

    static updateAllowSignup = async (token, val) => {
        let result = {
            data: null,
            error: null
        };

        await axios.post(`${API_URL}/settings/show-signups`, { val: val },
            { headers: { 'alshorja_auth': token } })
            .then(resp => {
                if (resp.status === 200) {
                    result.data = resp.data;
                }
            })
            .catch(err => {
                result.error = err.response ? err.response.data : (err.message || "Server Error");
            });

        return result;
    }

    static updateShowAnnouncement = async (token, show, text) => {
        let result = {
            data: null,
            error: null
        };

        const data = {
            show, text
        }

        await axios.post(`${API_URL}/settings/show-announcements`, data,
            { headers: { 'alshorja_auth': token } })
            .then(resp => {
                if (resp.status === 200) {
                    result.data = resp.data;
                }
            })
            .catch(err => {
                result.error = err.response ? err.response.data : (err.message || "Server Error");
            });

        return result;
    }

    static updateMaintenanceMode = async (token, show, text) => {
        let result = {
            data: null,
            error: null
        };

        const data = {
            show, text
        };

        await axios.post(`${API_URL}/settings/maintenance-mode`, data,
            { headers: { 'alshorja_auth': token } })
            .then(resp => {
                if (resp.status === 200) {
                    result.data = resp.data;
                }
            })
            .catch(err => {
                result.error = err.response ? err.response.data : (err.message || "Server Error");
            });

        return result;
    }

    static updateSimilarAds = async (token, show) => {
        let result = {
            data: null,
            error: null
        };

        const data = {
            show
        };

        await axios.post(`${API_URL}/settings/show-similar-ads`, data,
            { headers: { 'alshorja_auth': token } })
            .then(resp => {
                if (resp.status === 200) {
                    result.data = resp.data;
                }
            })
            .catch(err => {
                result.error = err.response ? err.response.data : (err.message || "Server Error");
            });

        return result;
    }

    static updateCurrencyExchange = async (token, show) => {
        let result = {
            data: null,
            error: null
        };

        const data = {
            show,
            val: show
        };

        await axios.post(`${API_URL}/settings/show-currency-exchange`, data,
            { headers: { 'alshorja_auth': token } })
            .then(resp => {
                if (resp.status === 200) {
                    result.data = resp.data;
                }
            })
            .catch(err => {
                result.error = err.response ? err.response.data : (err.message || "Server Error");
            });

        return result;
    }

    static updateCarouselSpeed = async (token, speed) => {
        let result = {
            data: null,
            error: null
        };

        const data = {
            speed
        };

        await axios.post(`${API_URL}/settings/carousel-speed`, data,
            { headers: { 'alshorja_auth': token } })
            .then(resp => {
                if (resp.status === 200) {
                    result.data = resp.data;
                }
            })
            .catch(err => {
                result.error = err.response ? err.response.data : (err.message || "Server Error");
            });

        return result;
    }

    static updateGoogleAdSense = async (token, data) => {
        let result = {
            data: null,
            error: null
        };

        await axios.post(`${API_URL}/settings/google-adsense`, data,
            { headers: { 'alshorja_auth': token } })
            .then(resp => {
                if (resp.status === 200) {
                    result.data = resp.data;
                }
            })
            .catch(err => {
                result.error = err.response ? err.response.data : (err.message || "Server Error");
            });

        return result;
    }
}